import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledMenu } from '@ui/components/common/Menu';
import { Iconly } from 'react-iconly';
const VehicleRowActionsMenu = ({ anchorEl, open, onClose, vehicleRow, commentCount = 5, isdisabled = false, onViewComments, onEdit, onDelete }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const actions = useMemo(() => {
        // const viewCommentsAction: StyledMenuAction = {
        //   text: t('events.eventDetails.transportTab.viewComments'),
        //   icon: <WheelChairIcon color={theme.palette.text.primary} />,
        //   endIcon:
        //     commentCount > 0 ? (
        //       <Chip
        //         label={String(commentCount)}
        //         size='small'
        //         sx={{ height: 20, minWidth: 24 }}
        //         color='primary'
        //         variant='soft'
        //       />
        //     ) : undefined,
        //   to: () => vehicleRow && onViewComments(vehicleRow)
        // };
        const editAction = {
            text: t('actions.edit'),
            icon: _jsx(Iconly, { name: 'Edit', set: 'curved', primaryColor: theme.palette.text.primary }),
            to: () => vehicleRow && onEdit?.(vehicleRow),
            group: true,
            disabled: isdisabled
        };
        const deleteAction = {
            text: t('actions.delete'),
            icon: _jsx(Iconly, { name: 'Delete', set: 'curved' }),
            color: 'error.light',
            to: () => vehicleRow && onDelete?.(vehicleRow),
            group: true,
            disabled: isdisabled
        };
        return [/* viewCommentsAction, */ editAction, deleteAction];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t, vehicleRow, commentCount, onViewComments, onEdit, onDelete]);
    return (_jsx(StyledMenu, { anchorEl: anchorEl, open: open, onClose: onClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, actions: actions }));
};
export default VehicleRowActionsMenu;
